import {
  CbhIcon,
  type CbhIconProps,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Text,
} from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";

interface LineItemProps {
  label: string;
  iconType: CbhIconProps["type"];
  onClick?: () => void;
}

function LineItem(props: LineItemProps) {
  const { label, iconType, onClick } = props;

  return (
    <>
      <ListItemButton hideCallToActionIcon onClick={onClick}>
        <ListItemIcon sx={{ minWidth: "2rem" }}>
          <CbhIcon type={iconType} />
        </ListItemIcon>
        <ListItemText primary={<Text semibold>{label}</Text>} />
        <CbhIcon type="chevron-right" size="small" />
      </ListItemButton>
      <Divider color="primary" />
    </>
  );
}

export function HelpAndSupport() {
  const { openArticle } = useZendeskArticle();
  const { clipboardScoreSupportLink } = useSupportLinks();

  return (
    <Stack spacing={4} sx={{ paddingY: 6 }}>
      <Text bold variant="h5">
        Help &amp; Support
      </Text>
      <Stack>
        <LineItem
          label="Frequently asked questions"
          iconType="info"
          onClick={async () => {
            await openArticle(clipboardScoreSupportLink);
          }}
        />
        <LineItem
          label="Chat with support"
          iconType="text-bubble"
          onClick={() => {
            void openZendeskMessaging();
          }}
        />
      </Stack>
    </Stack>
  );
}
